<template>
  <v-container class="component_main">
    <router-view></router-view>
    <v-row v-show="showList" class="px-6">
      <v-col cols=12>
        <h1>Consulta de pagamentos quitados</h1>
        <p>Acompanhe as informações dos pagamentos quitados</p>
      </v-col>
      <v-col cols=12>
       <PagamentosConsultaFilter
          :prestadores="prestadores"
          :operadoras="listOperadora"
          :mesCorrente="mesCorrente"
          :filterList="(formData, page, clear) => getList(formData, page, clear)"
          :formatDate="(date) => formatDate(date)"
          :parseDate="(date) => parseDate(date)"
          :statusList="statusList"
          />
      </v-col>
    </v-row>
    <v-row wrap class="px-6">
      <v-col class="col-xs-12 col-sm-12 col-md-12 py-0 px-4">
        <PagamentosConsultaList
          v-show="showList"
          :list="list"
          :pagination="pagination"
          :filterData="filterData"
          :getList="(filter, page) => getList(filter, page)"
          :getFile="() => downloadFile()"
          :statusList="statusList"
          :totais="totalConsultaQ"
          />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import PagamentosConsultaList from "@/components/recebiveis/pagamentos_quitados/List";
import PagamentosConsultaFilter from '@/components/recebiveis/pagamentos_quitados/Filter'

export default {
  components: {
    PagamentosConsultaList,
    PagamentosConsultaFilter
  },
  data() {
    return {
      list: [],
      controlResponsavel: true,
      showDados: false,
      pagination: {
        limit: 10,
        offset: 1,
        total_pages: 0,
      },
      filterData: {},
      prestadores: [],
      showList: true,
      showPgto: false,
      statusList:[],
      mesCorrente: {
        data_inicio: null,
        data_fim: null
      },
      totalConsultaQ: {
        valor_liberado: 0,
        valor_pago_liquido: 0,
        valor_informado_conciliado: 0,
        valor_imposto: 0,
        valor_desconto: 0
      }
    };
  },
  watch: {
    grupoEconomico:{
      deep: true,
      handler() {
        this.prestadores = this.$store.getters["permissions/getPrestadoresByGeco"]();
      }
    },
  },
  computed: {
    ...mapState({
      grupoEconomico: (state) => state.permissions.grupoEconomico,
      grupoEconomicoList: state =>state.permissions.grupoEconomicoList,
      listOperadora: (state) => state.faturamento.listOperadora,
      userData: (state) => state.userData.userData,
    }),
  },
  beforeMount() {
    this.getOperadoras({ prestador_ids:[], modulo_operadora: "recebiveis"})
  },
  mounted(){
    this.prestadores = this.$store.getters["permissions/getPrestadoresByGeco"]()
  },
  methods: {
    ...mapActions('permissions', [
      "getOperadoras",
    ]),
    formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
    parseDate (date) {
        if (!date) return null
        const [day, month, year] = date.split('/')
        return `${year}-${month}-${day}`
    },
    getList(filter, page, clear) {
      this.filterData = filter
      this.pagination.offset = page? page : 1
      if(clear){
        this.mesCorrente.data_inicio = null
        this.mesCorrente.data_fim = null
        this.pagination.total_pages = 0
        this.pagination.offset = 1
        this.list = []
        return
      }
      let payload = filter != null 
        ? Object.assign({ grupo_economico: this.grupoEconomico, ...this.pagination, prestador_id:[], operadora_ans_id:[], ...filter }) 
        : Object.assign({ grupo_economico: this.grupoEconomico, prestador_id:[], operadora_ans_id:[],...this.pagination})
      let obj = {
        query: [{
          Modulo: "Recebiveis",
          Acao: "getpagamentosquitados",
          Payload: payload,
        }],
      }
      this.$store.dispatch('request/doRequest', obj).then((response) => {
        if (!response || response.isAxiosError || response.error) {
          this.$store.commit("hideLoader")
          return
        }
        let { dados, total_pages, current_page, data_inicio, data_fim, valor_liberado, valor_pago_liquido, valor_informado_conciliado, valor_imposto, valor_desconto } = response
        this.mesCorrente.data_inicio = data_inicio.split('T')[0]
        this.mesCorrente.data_fim = data_fim.split('T')[0]
        this.pagination.total_pages = total_pages
        this.pagination.offset = current_page
        this.list = dados
        this.totalConsultaQ.valor_liberado = valor_liberado
        this.totalConsultaQ.valor_pago_liquido = valor_pago_liquido
        this.totalConsultaQ.valor_informado_conciliado = valor_informado_conciliado
        this.totalConsultaQ.valor_imposto = valor_imposto
        this.totalConsultaQ.valor_desconto = valor_desconto
      })
    },
    downloadFile() {
        let acao = "getcsvpagamentosquitados"
        let Payload = {grupo_economico: this.grupoEconomico, ...this.filterData}
        this.$store.dispatch("documents/getDocumentPost", { Payload, acao }, {root:true})
    },
  }
};
</script>
<style>
</style>